export default __webpack_public_path__ + "static/home-page-career-law-fd41e80124cd0bf01233d99609d4d0bb.png";